(function (global) {
  "use strict";

  function modeFromSearch(search) {
    var token = new URLSearchParams(search || "").get("bbRevision") || "";
    return token
      ? { mode: "paid-order-revision", token: token }
      : { mode: "shopping", token: "" };
  }

  function shouldMutateCart(mode) {
    return mode !== "paid-order-revision";
  }

  function initialState(mode) {
    return {
      mode: mode,
      status: mode === "paid-order-revision" ? "loading" : "idle",
    };
  }

  function transition(state, event) {
    var next = { mode: state.mode, status: state.status };
    if (state.mode !== "paid-order-revision") return next;
    if (event === "CONTEXT_READY" && state.status === "loading")
      next.status = "editing";
    if (event === "CONTEXT_ERROR") next.status = "error";
    if (event === "SAVE" && state.status === "editing")
      next.status = "submitting";
    if (event === "SUBMIT_OK" && state.status === "submitting")
      next.status = "complete";
    if (event === "SUBMIT_ERROR" && state.status === "submitting")
      next.status = "error";
    if (event === "RETRY" && state.status === "error")
      next.status = "loading";
    return next;
  }

  global.BBArtworkRevisionModel = {
    modeFromSearch: modeFromSearch,
    shouldMutateCart: shouldMutateCart,
    initialState: initialState,
    transition: transition,
  };
})(window);
